import React, {useEffect, useState} from 'react'
import { Dropdown, Grid, Input, Button, Icon } from 'semantic-ui-react'
import {useForm, Controller} from "react-hook-form"
import FacebookData from "../Sections/FacebookData"
import './style.css'

const FACEBOOK_SQL_WEBHOOK = "https://api.axc.ae/webhook/b1acf1f9-ffab-4131-9379-7bfb7cea29fe";

const sqlString = (value) => {
    if (value === undefined || value === null || value === '') {
        return 'NULL';
    }

    return `'${value.toString().replace(/'/g, "''")}'`;
}

const sqlNumber = (value) => {
    if (value === undefined || value === null || value === '') {
        return 'NULL';
    }

    return Number(value);
}

const sqlJsonb = (value) => {
    const jsonValue = JSON.stringify(Array.isArray(value) ? value : []);

    return `'${jsonValue.replace(/'/g, "''")}'::jsonb`;
}

const buildFacebookInsertSql = (fields) => `
INSERT INTO fb_forms (
    form_id,
    "Ad_Project",
    "Ad_Language",
    "Source details",
    "Responsible",
    marker,
    tags
)
VALUES (
    ${sqlNumber(fields.form_id)},
    ${sqlNumber(fields.Ad_Project)},
    ${sqlNumber(fields.Ad_Language)},
    ${sqlString(fields.source_detail)},
    ${sqlNumber(fields.responsible)},
    ${sqlString(fields.marker)},
    ${sqlJsonb(fields.tags)}
)
RETURNING form_id;`.trim();

const FB = () => {
    const {
        control,
        handleSubmit,
        reset
    } = useForm()

    const [projects, setProject] = useState([])
    const [language, setLanguage] = useState([])
    const [responsible, setResponsible] = useState([])
    const [tags, setTags] = useState([])
    const [responseMessage, setResponseMessage] = useState('');
    const [lastCreatedFormId, setLastCreatedFormId] = useState('');
    const [refreshKey, setRefreshKey] = useState(0);

    async function adProject(){
        const response = await fetch('https://crm.axcap.ae/rest/1/a9czkhedx3mmmn04/crm.lead.userfield.list?filter%5BFIELD_NAME%5D=UF_CRM_1568907438');
        const data = await response.json();
        setProject(data.result?.[0]?.LIST || [])
    }

    async function adLang(){
        const response = await fetch('https://crm.axcap.ae/rest/1/a9czkhedx3mmmn04/crm.lead.userfield.list?filter%5BFIELD_NAME%5D=UF_CRM_1553165368131');
        const data = await response.json();
        setLanguage(data.result?.[0]?.LIST || [])
    }

    async function adResponsible(){
        const response = await fetch('https://crm.axcap.ae/local/webhooks/getUserIdName.php?api_key=UPmcMSpk86SLPprv');
        const data = await response.json();
        setResponsible(data)
    }

    async function adTags(){
        let start = 0;
        let allTags = [];

        while (start !== null) {
            const response = await fetch(`https://crm.axcap.ae/rest/1/a9czkhedx3mmmn04/lists.element.get?IBLOCK_TYPE_ID=lists&IBLOCK_ID=189&ELEMENT_ORDER%5BID%5D=ASC&start=${start}`);
            const data = await response.json();

            allTags = allTags.concat(data.result || []);
            start = data.next ?? null;
        }

        setTags(allTags)
    }
    
    useEffect(() => {
        adProject();
        adLang();
        adResponsible();
        adTags();
    }, [])

    const transformProject = projects.map(project => ({
        key: project.ID,
        text: project.VALUE,
        value: project.ID
    }))

    const transformLanguage = language.map(languageItem => ({
        key: languageItem.ID,
        text: languageItem.VALUE,
        value: languageItem.ID
    }))

    const transformResponsible = responsible.map(responsibleItem => ({
        key: responsibleItem.ID,
        text: responsibleItem.NAME,
        value: responsibleItem.ID
    }))
    transformResponsible.push({key: 1, text: 'AX CAPITAL', value: '1'})

    const transformTags = tags.map(tag => ({
        key: tag.ID,
        text: tag.NAME,
        value: tag.ID
    }))

    const onSubmit = async (fields) => {
        try {
            const sql = buildFacebookInsertSql(fields);
            const response = await fetch(FACEBOOK_SQL_WEBHOOK, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify({fields, sql, source: "facebook"})
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            setResponseMessage(data);
            setLastCreatedFormId(fields.form_id || '');
            reset();
            setRefreshKey(prevKey => prevKey + 1);
        } catch (error) {
            console.error('Error:', error);
            setResponseMessage('An error occurred');
            setLastCreatedFormId('');
        }
    }

    return(
        <>
            <h1 className='title'>- Facebook -</h1>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container columns='equal' className='grid-form'>
                    <Grid.Row>
                        <Grid.Column>
                            <div className='item'>
                                <span>Form ID</span>
                                <Controller
                                    name='form_id'
                                    defaultValue=""
                                    control={control}
                                    render={({field}) => <Input type='text' placeholder='Insert...' {...field}/>}
                                />
                            </div>
                        </Grid.Column>
                        <Grid.Column>
                            <div className='item'>
                                <span>Responsible</span>
                                <Controller
                                    name='responsible'
                                    control={control}
                                    render={({ field: { onChange, value, ...field } }) => (
                                        <Dropdown
                                            placeholder='select responsible'
                                            fluid
                                            search
                                            selection
                                            options={transformResponsible}
                                            value={value}
                                            onChange={(e, data) => onChange(data.value)}
                                            {...field}
                                        />
                                    )}
                                />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <div className='item'>
                                <span>Project</span>
                                <Controller
                                    name='Ad_Project'
                                    control={control}
                                    render={({ field: { onChange, value, ...field } }) => (
                                        <Dropdown
                                            placeholder='Select Project'
                                            fluid
                                            search
                                            selection
                                            options={transformProject}
                                            value={value}
                                            onChange={(e, data) => onChange(data.value)}
                                            {...field}
                                        />
                                    )}
                                />
                            </div>
                        </Grid.Column>
                        <Grid.Column>
                            <div className='item'>
                                <span>Language</span>
                                <Controller
                                    name='Ad_Language'
                                    control={control}
                                    render={({ field: { onChange, value, ...field } }) => (
                                        <Dropdown
                                            placeholder='Select Language'
                                            fluid
                                            search
                                            selection
                                            options={transformLanguage}
                                            value={value}
                                            onChange={(e, data) => onChange(data.value)}
                                            {...field}
                                        />
                                    )}
                                />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <div className='item'>
                                <span>Source Details</span>
                                <Controller
                                    name='source_detail'
                                    defaultValue=""
                                    control={control}
                                    render={({field}) => <Input placeholder='Insert...' {...field}/>}
                                />
                            </div>
                        </Grid.Column>
                        <Grid.Column>
                            <div className='item'>
                                <span>Marker</span>
                                <Controller
                                    name='marker'
                                    defaultValue=""
                                    control={control}
                                    render={({field}) => <Input placeholder='Insert...' {...field}/>}
                                />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <div className='item'>
                                <span>Tags</span>
                                <Controller
                                    name='tags'
                                    defaultValue={[]}
                                    control={control}
                                    render={({ field: { onChange, value, ...field } }) => (
                                        <Dropdown
                                            placeholder='Select Tags'
                                            fluid
                                            multiple
                                            search
                                            selection
                                            options={transformTags}
                                            value={value || []}
                                            onOpen={adTags}
                                            onChange={(e, data) => onChange(data.value)}
                                            {...field}
                                        />
                                    )}
                                />
                            </div>
                        </Grid.Column>
                        <Grid.Column />
                    </Grid.Row>
                    <Button animated className='fb-button'>
                        <Button.Content visible>Create Integration</Button.Content>
                        <Button.Content hidden>
                            <Icon name='arrow right' />
                        </Button.Content>
                    </Button>
                </Grid>
            </form>
            {responseMessage && (
                <div className="reponse-message">
                    <p>
                        {typeof responseMessage === 'string'
                            ? responseMessage
                            : `Response: ${responseMessage.message || 'done'} | Form ID: ${responseMessage.id || responseMessage.form_id || lastCreatedFormId}`}
                    </p>
                </div>
            )}
            <FacebookData refreshKey={refreshKey}/>
        </>
    )
}

export default FB;
